import { ComponentsOverrides, Theme } from '@mui/material'
import { FONTS } from './fonts'
import { palette } from './palette'

export const globalClasses = {
  ellipsis: 'ellipsis',
  ellipsis2Lines: 'ellipsis-2-lines',
  fullHeight: 'h-100',
  fullWidth: 'w-100',
  noBreak: 'no-break',
  visibilityHidden: 'visibility-hidden',
  hidden: 'hidden',
}

export const globalStyles: ComponentsOverrides<Theme>['MuiCssBaseline'] = `
  :root {
    --background: ${palette.background?.default};
    --foreground: #0a0a0a;
  }

  @media (prefers-color-scheme: dark) {
    :root {
      --background: ${palette.background?.default};
      --foreground: #0a0a0a;
    }
  }

  * {
    box-sizing: border-box;
  }

  html,
  body {
    max-width: 100vw;
    margin: 0;
    padding: 0;
  }

  body {
    color: var(--foreground);
    background: var(--background);
    font-family: ${FONTS.PRIMARY}, ${FONTS.FALLBACK};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .${globalClasses.ellipsis} {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .${globalClasses.ellipsis2Lines} {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  .${globalClasses.fullHeight} {
    height: 100%;
  }
  
  .${globalClasses.fullWidth} {
    width: 100%;
  }

  .flex {
    display: flex;
  }

  .${globalClasses.noBreak} {
    white-space: nowrap;
  }

  .${globalClasses.visibilityHidden} {
    visibility: hidden;
  }
  
  .${globalClasses.hidden} {
    display: none;
  }

  @media (prefers-color-scheme: dark) {
    html {
      color-scheme: dark;
    }
  }
`
